import { Outlet } from "react-router-dom";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";

export function AppLayout() {
  return (
    <TooltipProvider delayDuration={200}>
      <div className="flex min-h-screen">
        <Sidebar />
        <div className="flex flex-1 flex-col min-w-0">
          <Header />
          <main className="flex-1 px-4 py-5 md:px-6 md:py-6 lg:px-8 lg:py-8 max-w-[1600px] mx-auto w-full">
            <Outlet />
          </main>
        </div>
      </div>
    </TooltipProvider>
  );
}
